<section class="sect-how" id="como" appViewportEnterDirective (viewPortEntered)="activeRoute.setActiveRoute('home-how')">
    <img class="texture" src="./assets/how-texture.png" alt="textura de fondo">
    <h2>¿Cómo funciona?</h2>
    <ul>
        <li>
            <span class="number">1</span>
        </li>
        <li>
                <div>
                    <p>
                        <span>Registrate</span>, cargá los datos de tu administración y elegí el plan que se adapte a tus necesidades.
                    </p>
                </div>
        </li>
        <li>
            <span class="number">2</span>
        </li>
        <li>
            <div>
                <p>
                    <span>Comenzá a cargar los datos</span> de cada consorcio. <br />¡Nuestro equipo de implementación te puede asistir sin cargo en el proceso!
                </p>
            </div>
        </li>
        <li>
            <span class="number">3</span>
        </li>
        <li>
            <div>
                <p>
                    <span>Conectá el Whatsapp de tu administración </span> a la plataforma a través del <span>QR... ¡y listo!</span><br /> AdminAI ya está trabajando para vos.
                </p>
            </div>
        </li>
    </ul>
</section>
